import type { PatientCardInfoState, RootState } from "@/lib/types/state";

export const selectPatientCardInfo = (state: RootState): PatientCardInfoState => {
  return state?.patientCardInfo;
};

export const selectShowPaywall = (state: RootState): boolean | undefined => {
  return state?.patientCardInfo?.showPaywall;
};
